/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Feb 2022
 * @flow
 */

import React from 'react';
import Sections from '../Sections';
import Header from '../Header';
import classes from './Body.module.css';

const Body = props => {
  const {
    goBack,
    showPopup,
    parentRoute,
    onFooterButtonPress,
    pendingCheckList,
    comingUpCheckList,
    inProgressCheckList,
    completeCheckList,
    seeCounterCheckList,
    onChangeSortBy,
    sortByTime,
  } = props;
  const showBack = parentRoute === 'fireboard';

  return (
    <div className={classes.bodyContainer}>
      <Header goBack={goBack} showBack={showBack} onChangeSortBy={onChangeSortBy} sortByTime={sortByTime} />
      <Sections
        pendingCheckList={pendingCheckList}
        comingUpCheckList={comingUpCheckList}
        inProgressCheckList={inProgressCheckList}
        completeCheckList={completeCheckList}
        seeCounterCheckList={seeCounterCheckList}
        showPopup={showPopup}
        onFooterButtonPress={onFooterButtonPress}
      />
    </div>
  );
}

export default Body;
